import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const companyColumns: TableColumnsType<Company> = [
  {
    title: "Groep",
    dataIndex: "groupName",
    key: "groupName",
    render: (text: string, record) =>
      text ? <a href={`/companies/${record.id}`}>{text}</a> : null,
  },
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (text: string, record) => (
      <a href={`/companies/${record.id}`}>{text}</a>
    ),
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "E-mail",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Telefoon",
    dataIndex: "telephone",
    key: "telephone",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/companies/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
